import axios from 'axios';

export function addExtraWorkEntry(extraWorkEntry) {
    return axios.post(
        `/api/warehousing/customer/extraWork/${extraWorkEntry.customerId}/${extraWorkEntry.extraWorkItemId}`,
        extraWorkEntry,
    );
}

export function updateExtraWorkEntry(extraWorkEntry) {
    return axios.put(
        `/api/warehousing/customer/extraWork/${extraWorkEntry.customerId}/${extraWorkEntry.id}`,
        extraWorkEntry,
    );
}

export function deleteExtraWorkEntry(extraWorkEntry) {
    return axios.delete(`/api/warehousing/customer/extraWork/${extraWorkEntry.id}`);
}

export function getExtraWorkEntries(customerId) {
    return axios.get(`/api/warehousing/customer/extraWork/${customerId}`);
}

export function getMonthExtraWorkEntries(customerId, month) {
    return axios.get(`/api/warehousing/customer/extraWork/${customerId}/${month}`);
}
